import { render, staticRenderFns } from "./top_up.vue?vue&type=template&id=a4f7abdc&scoped=true&"
import script from "./top_up.vue?vue&type=script&lang=js&"
export * from "./top_up.vue?vue&type=script&lang=js&"
import style0 from "./top_up.vue?vue&type=style&index=0&id=a4f7abdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f7abdc",
  null
  
)

export default component.exports